import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const apiErrorSlice = createSlice({
  name: "ERROR_HANDLER",
  initialState,
  reducers: {
    setError: {
      reducer: (state, action) => {
        return {
          [action.payload]: true,
          ...state,
        };
      },
    },
    clearErrors: () => initialState,
  },
});

export const { setError, clearErrors } = apiErrorSlice.actions;

export default apiErrorSlice.reducer;
